import { ensureCsrfCookie, http } from "./http";

export type Role = "superadmin" | "master" | "franqueado" | "cliente";

export interface Organization {
  id: string;
  name: string;
  slug: string;
  tier: string;
  status: string;
}

export interface AuthUser {
  id: string;
  name: string;
  email: string;
  role: Role;
  role_label: string;
  locale: string | null;
  is_active: boolean;
  last_login_at: string | null;
  permissions: string[];
  organizations?: Organization[];
}

/** Contratos de /api/auth/* — ver docs/API.md */
export const authService = {
  async login(email: string, password: string, remember = false): Promise<AuthUser> {
    await ensureCsrfCookie(true);
    return http.post<AuthUser>("/auth/login", { email, password, remember });
  },
  me: () => http.get<AuthUser>("/auth/me"),
  logout: () => http.post<{ message: string }>("/auth/logout"),
  updateProfile: (payload: { name: string; email: string; locale?: string }) =>
    http.put<AuthUser>("/auth/profile", payload),
  changePassword: (payload: {
    current_password: string;
    password: string;
    password_confirmation: string;
  }) => http.put<{ message: string }>("/auth/password", payload),
  forgotPassword: (email: string) =>
    http.post<{ message: string }>("/auth/forgot-password", { email }),
};
